export const DDZ_INVITE_PATH = "/ddz/invite";

export function readInviteToken(value) {
  if (typeof value !== "string" || !/^ehi_[a-f0-9]{48}$/.test(value)) throw new Error("INVALID_INVITE");
  return value;
}

// Share URLs identify an invitation. Room details always come from the server.
export function inviteFromSearch(search) {
  const values = new URLSearchParams(search).getAll("invite_token");
  if (!values.length) return null;
  return values.length === 1 ? values[0] : "";
}

export function inviteLocation(inviteToken) {
  return `${DDZ_INVITE_PATH}?invite_token=${encodeURIComponent(inviteToken)}`;
}

export function readInvitePreview(info) {
  if (!info || info.code !== "OK" ||
      !Number.isSafeInteger(info.game_id) || info.game_id <= 0 ||
      !Number.isSafeInteger(info.room_code) || info.room_code <= 0 ||
      !Number.isSafeInteger(info.club_id) || info.club_id < 0 ||
      !Number.isSafeInteger(info.capacity) || info.capacity <= 0 ||
      !Number.isSafeInteger(info.seat_count) || info.seat_count < 0 || info.seat_count > info.capacity ||
      !Number.isSafeInteger(info.expires_at) || info.expires_at <= 0) throw new Error("INVALID_INVITE_RESPONSE");
  if (info.expires_at * 1000 <= Date.now()) throw new Error("INVITE_EXPIRED");
  return { game_id: info.game_id, room_code: info.room_code, club_id: info.club_id,
    capacity: info.capacity, seat_count: info.seat_count, expires_at: info.expires_at };
}
